import { BoxV2 as Box, Button, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

import { Modal } from '@/components';

interface RcsVetPendingModalProps {
  open?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
}

const Title: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      paddingTop: 's',
      paddingBottom: 's',
      color: 't.black80',
      fontWeight: 600,
      fontSize: 'H600',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const Message: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      paddingBottom: 'xs',
      color: 't.black80',
      fontWeight: 400,
      fontSize: 'H400',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const Actions: FunctionComponent = ({ children }) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      gap: '18px',
      padding: '30px 0',
    }}
  >
    {children}
  </Flex>
);

const RcsVetPendingModal: FunctionComponent<RcsVetPendingModalProps> = ({
  open = false,
  onCancel,
  onSubmit,
}) => (
  <Modal open={open}>
    <Title>RCS Vet Pending</Title>
    <Message>
      This brand has a pending RCS vet. You may continue with registration, but
      its final status may be affected by the outcome.
    </Message>
    <Actions>
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button onClick={onSubmit}>Continue</Button>
    </Actions>
  </Modal>
);

export default RcsVetPendingModal;
